import { Identifiable, Project } from "@planzone/dto";

function match(
  first: Identifiable<Project>[],
  second: Identifiable<Project>[],
) {
  const uniqueIds = new Set([
    ...first.map(({ uuid }) => uuid),
    ...second.map(({ uuid }) => uuid),
  ]);

  return uniqueIds.size === first.length && uniqueIds.size === second.length;
}

export { match };
